import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Input, Grid, Button } from '../../components';
import Masks from '../../utils/masks';
import { trataMensagensErro } from '../../utils/requests';

class FiltroConsultaCpf extends Component {
  constructor() {
    super();
    this.filtroConsultaCpf = JSON.parse(sessionStorage.getItem('filtroConsultaCpf'));
    this.state = {
      cpf:
        this.filtroConsultaCpf && this.filtroConsultaCpf.cpf ?
          this.filtroConsultaCpf.cpf : null,
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem('filtroConsultaCpf')) {
      this.handleSearchButton();
    }
  }

  preparaNovaConsulta = () => {
    let filtroPesquisa = {
      cpf: null,
    };
    filtroPesquisa = JSON.stringify(filtroPesquisa);
    sessionStorage.setItem('filtroConsultaCpf', filtroPesquisa);

    this.setState({
      cpf: null,
    });
  }

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  handleKeyDown = (e) => {
    let retorno = null;
    if (e.keyCode === 13) {
      retorno = this.handleSearchButton();
    }
    return retorno;
  }

  handleSearchButton = () => {
    let filtroPesquisa = {
      cpf: this.state.cpf,
    };
    filtroPesquisa = JSON.stringify(filtroPesquisa);
    sessionStorage.setItem('filtroConsultaCpf', filtroPesquisa);
    this.setState(
      {
        cliqueiNoBotao: 1,
      },
      () => {
        this.handleChange({
          value: 1,
          isValid: true,
        }, 'cliqueiNoBotao');
      },
    );

    this.handleSearch();
  }

  handleListFilter = () => {
    const listaFiltrada = this.props.list;
    this.props.handleChangeList(listaFiltrada);
  }

  handleSearch = () => {
    let paramCpf = '';
    if (this.state.cpf) {
      paramCpf = this.state.cpf.toUpperCase();
      if (this.state.cpf.indexOf('_') !== -1) {
        paramCpf = this.state.cpf.toString().replace(/_/g, '');
      }
    }
    this.state.cpf = paramCpf;
    if (this.state.cpf) {
      this.props.handleSearchFilter(this.state);
    } else {
      trataMensagensErro(['Informe o CPF para pesquisa.']);
    }
  }

  montaFiltro = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="3 3 3 3">
          <Input
            cpf
            integer
            label="CPF"
            mask={Masks.cpf}
            onChange={e => this.handleChange(e, 'cpf')}
            onKeyDown={e => this.handleKeyDown(e, 'cpf')}
            showMask
            value={this.state.cpf}
            validationState="active"
          />
        </Grid>
      </div>
    </React.Fragment>
  )

  render() {
    const filtrosPesquisa = this.montaFiltro();
    if (!filtrosPesquisa) {
      return null;
    }
    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="pesquisa"
          panelId="filtro-pesquisa"
          icon="ico-filter"
          title="Filtro de Pesquisa"
        >
          {filtrosPesquisa}
          <div className="row">
            <Button
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearchButton()}
              hint="Pesquisar de acordo com o  CPF informado."
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}

FiltroConsultaCpf.propTypes = {
  handleChangeList: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  list: PropTypes.array,
}.isRequired;

export default FiltroConsultaCpf;



// WEBPACK FOOTER //
// ./src/pages/consulta-cpf/FiltroConsultaCpf.jsx